'use client';

import { useContext } from 'react';
import { Android, Apple, BookBase } from '@doist/icons/brand';
import { Box, Button, Container, Heading, Text } from '@doist/marketist';
import Nyt from 'app/[locale]/features/components/reviews-section/nyt.svg';
import cn from 'clsx';
import { Award } from 'components/award/award';
import GetStartedButton from 'components/Get-Started-Button/Get-Started-Button';
import { useTranslation } from 'next-i18next';
import { useCTAsData } from 'services/hooks/use-ctas-data';
import css from './cta.module.css';
import { UserContextV2 } from '@/app/services/providers/contexts/user-context';
export function Cta() {
  const {
    user
  } = useContext(UserContextV2);
  const isAuthenticated = Boolean(user);
  const {
    t
  } = useTranslation('pricing_v2_3');
  const ctaData = useCTAsData('pricing-page-prefooter');
  const content = {
    title: t(`ctaSection.${isAuthenticated ? 'loggedInTitle' : 'title'}`, {
      count: 30
    }),
    subtitle: t(`ctaSection.${isAuthenticated ? 'loggedInSubtitle' : 'subtitle'}`)
  };
  if (!ctaData && isAuthenticated) {
    // This indicates a business admin and member is logged in.
    // Don't display the CTA section as there is no action to take.
    return <Box className="pbe-96" style={{
      backgroundColor: 'var(--composition-background-neutral)'
    }} />;
  }
  return <Box className={cn('pbe-96 pbs-64 md-pbs-192', css.backgroundWrapper)} data-sentry-element="Box" data-sentry-component="Cta" data-sentry-source-file="cta.tsx">
            <Container width="sm" data-sentry-element="Container" data-sentry-source-file="cta.tsx">
                <Box className={cn(css.awardsContainer)} data-sentry-element="Box" data-sentry-source-file="cta.tsx">
                    <Award icon={<Apple />} data-sentry-element="Award" data-sentry-source-file="cta.tsx">{t('appDay')}</Award>
                    <Award icon={<Nyt />} className={css.awardMiddle} data-sentry-element="Award" data-sentry-source-file="cta.tsx">
                        {t('bestToDoListApp')}
                    </Award>
                    <Award icon={<Android />} data-sentry-element="Award" data-sentry-source-file="cta.tsx">{t('bestWear')}</Award>
                </Box>
                <Box className={css.contentContainer} data-sentry-element="Box" data-sentry-source-file="cta.tsx">
                    <Heading level="2" size="major-lg" className="mbs-48 mbe-24" data-sentry-element="Heading" data-sentry-source-file="cta.tsx">
                        {content.title}
                    </Heading>
                    <Text size="body-lg" className={cn('mbe-24', css.subtitle)} data-sentry-element="Text" data-sentry-source-file="cta.tsx">
                        {content.subtitle}
                    </Text>
                    {ctaData ? <Button variant={ctaData.variant} size="large" href={ctaData.href} className={cn(css.button, ctaData.className, 'mbe-12')} {...ctaData.dataAttributes}>
                            {ctaData.text}
                        </Button> : <Box className="mbe-12">
                            <GetStartedButton size="xl" />
                        </Box>}
                    <Button href="/help/articles/teams-faq-lQhBHo0y6" variant="tertiary" className="mbs-12" startIcon={BookBase} data-sentry-element="Button" data-sentry-source-file="cta.tsx">
                        {t('ctaSection.readTheFaq')}
                    </Button>
                </Box>
            </Container>
        </Box>;
}